/**
 * @format
 */
import { Injectable } from "@angular/core";
import { TagViewItem } from "./tags-mapping-modal/tag-mapping-modal.component";
import { PreviewEditTemplateActions } from "../../preview-edit-template/state/preview-edit-template.actions";
import { Store } from "@ngrx/store";
import { BehaviorSubject, Subject } from "rxjs/index";
import { tap } from "rxjs/operators";
import { Subscription } from "rxjs/internal/Subscription";
import { Observable } from "rxjs/internal/Observable";

@Injectable({
   providedIn: "root",
})
export class SmsConversionService {
   private tagItemList: Array<Partial<TagViewItem>>;
   private event: Subject<string>;
   private displayButtonEvent: BehaviorSubject<boolean>;

   constructor(private store: Store) {
      this.initializeTagsList();
      this.event = new Subject();
      this.displayButtonEvent = new BehaviorSubject(false);
   }

   private initializeTagsList(): void {
      this.tagItemList = [
         {
            ar2tag: "[@@profilename]",
            ar3tag:
               '<template-context label="firstname" th:text="${person.firstName}" th:remove="tag" ng-version="9.1.7" contenteditable="false"><span class="label2 label-info">firstname <span>×</span></span></template-context>',
            regExp: new RegExp("\\[@@profilename\\]", "g"),
         },
         {
            ar2tag: "[@@company]",
            ar3tag:
               '<template-context label="company" th:remove="tag" th:text="${account.companyName}" ng-version="9.1.7" contenteditable="false"><span class="label2 label-info">company <span>×</span></span></template-context>',
            regExp: new RegExp("\\[@@company\\]", "g"),
         },
         {
            ar2tag: "[@TEXTWHEN] [@@EEEE] [@@MMMM] [@@dd] at [@@h] : [@@mm] [@@aaaa]",
            ar3tag:
               '<template-context label="SMS appointment time" th:remove="tag" th:text="${#temporals.format(appointment.appointmentTimeLocal,__${(template.smsDateFormat != null and template.smsDateFormat != \'\'? template.smsDateFormat: locale.smsDateFormat)}__)}" ng-version="9.1.7" contenteditable="false"><span class="label2 label-info">SMS appointment time <span>×</span></span></template-context>',
            regExp: new RegExp(
               "\\[@TEXTWHEN\\]\\s*\\[@@EEEE\\]\\s*\\[@@MMMM\\]\\s*\\[@@dd\\]\\s*at\\s*\\[@@h\\]\\s*:\\s*\\[@@mm\\]\\s*\\[@@aaaa\\]",
               "g"
            ),
         },
         {
            ar2tag: "[@@confirm]",
            ar3tag:
               '<template-context label="confirm keyword" th:remove="tag">$$$$$$confirm$$$$$$</template-context>',
            regExp: new RegExp("\\[@@confirm\\]", "g"),
         },
         {
            ar2tag: "[@@contactphone]",
            ar3tag:
               '<template-context label="contact phone" th:remove="tag" th:text="${account.contactPhone}" ng-version="9.1.7" contenteditable="false"><span class="label2 label-info">contact phone <span>×</span></span></template-context>',
            regExp: new RegExp("\\[@@contactphone\\]", "g"),
         },
         {
            ar2tag: "[@@profileprefix]",
            ar3tag:
               '<template-context label="person prefix" th:text="${person.prefix}" th:remove="tag" ng-version="9.1.7" contenteditable="false"><span class="label2 label-info">person prefix <span>×</span></span></template-context>',
            regExp: new RegExp("\\[@@profileprefix\\]", "g"),
         },
      ];
   }

   getTagItemList(): Array<Partial<TagViewItem>> {
      return this.tagItemList;
   }

   replaceAR2TagForAR3InValue(value: string): string {
      let auxValue = value;
      this.tagItemList.forEach((tagItem) => {
         auxValue = auxValue.replace(tagItem.regExp, tagItem.ar3tag);
      });
      return auxValue;
   }

   updateValueOnTemplateModel(value: string, templateVariable: string): void {
      this.store.dispatch(
         PreviewEditTemplateActions.templateUpdateModelVariable({
            variableName: templateVariable,
            value: value,
            reloadPreview: false,
         })
      );
   }

   triggerConversion(): void {
      this.event.next("CONVERT_SMS");
   }

   listenConversion(handler: () => void): Subscription {
      return this.event.asObservable().pipe(tap(handler)).subscribe();
   }

   displayButton(value: boolean): void {
      this.displayButtonEvent.next(value);
   }

   listenDisplayButton(): Observable<boolean> {
      return this.displayButtonEvent.asObservable();
   }
}
